<template>
  <ul class="flex flex-col space-y-1">
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.pipeline.view)"
      v-hubble="'data-products'"
      :to="routes.dataProducts"
      :label="$t('pages.dataProducts.title')"
      :is-active="isActiveRoute(routes.dataProducts.name)"
    >
      <cx-icon :name="getIconName(routes.dataProducts.name, icons.dataProducts)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="canViewHealthDashboard"
      v-hubble="'health-dashboard'"
      :to="routes.healthDashboard"
      :label="$t('menuItems.healthDashboard')"
      :is-active="isActiveRoute(routes.healthDashboard.name)"
      @click="trackHealthDashboardClick"
    >
      <cx-icon :name="getIconName(routes.healthDashboard.name, icons.healthDashboard)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.connection.viewAll)"
      v-hubble="'connections'"
      :to="routes.connectionSettings"
      :label="$t('menuItems.connections')"
      :is-active="isActiveRoute(routes.connectionSettings.name)"
    >
      <cx-icon :name="getIconName(routes.connectionSettings.name, icons.connectionSettings)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.backfill.view)"
      :to="routes.backfill"
      :label="$t('menuItems.backfill')"
      :is-active="isActiveRoute(routes.backfill.name)"
    >
      <cx-icon :name="getIconName(routes.backfill.name, icons.backfill)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.catalog.view)"
      v-hubble="'catalog'"
      :to="routes.catalog"
      :label="$t('menuItems.catalog')"
      :is-active="isActiveRoute(routes.catalog.name)"
      @click="trackCatalogClick"
    >
      <cx-icon :name="getIconName(routes.catalog.name, icons.catalog)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.org.view)"
      v-hubble="'organizations'"
      :to="routes.organizations"
      :label="$t('menuItems.organizations')"
      :is-active="isActiveRoute(routes.organizations.name)"
    >
      <cx-icon :name="getIconName(routes.organizations.name, icons.organizations)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="false"
      v-hubble="'users'"
      :to="routes.users"
      :is-active="isActiveRoute(routes.users.name)"
      :label="$t('menuItems.users')"
    >
      <cx-icon :name="getIconName(routes.users.name, icons.users)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="$hasEntitlement(entitlements.notification.view)"
      v-hubble="'notifications'"
      :to="routes.notifications"
      :is-active="isActiveRoute(routes.notifications.name)"
      :label="$t('menuItems.notifications')"
    >
      <cx-icon :name="getIconName(routes.notifications.name, icons.notifications)" size="2xl" />
    </app-sidebar-item>
    <app-sidebar-item
      v-if="canViewMetadataNavigator"
      v-hubble="'navigator'"
      :to="routes.navigator"
      :is-active="isActiveRoute(routes.navigator.name)"
      :label="$t('menuItems.navigator')"
    >
      <cx-icon :name="getIconName(routes.navigator.name, icons.navigator)" size="2xl" />
    </app-sidebar-item>
  </ul>
</template>

<script>
import { CxIcon } from '~/components/cx';
import { ENTITLEMENTS, NAV_ICONS, NAV_ROUTES } from '~/support/constants';
import { navigation } from '~/support/utils';

import AppSidebarItem from '../AppSidebarItem';

export default {
  name: 'AppSidebarLinks',

  hubble: 'app-sidebar-links',

  components: {
    AppSidebarItem,
    CxIcon,
  },

  computed: {
    canViewHealthDashboard() {
      return this.$hasEntitlement(ENTITLEMENTS.healthDashboard.view) && this.$flag('showHealthDashboardV2');
    },

    canViewMetadataNavigator() {
      return this.$hasEntitlement(ENTITLEMENTS.navigator.view) && this.$flag('showMetadataNavigator');
    },

    entitlements() {
      return ENTITLEMENTS;
    },

    icons() {
      return NAV_ICONS;
    },

    routes() {
      return NAV_ROUTES;
    },
  },

  methods: {
    getIconName(route, icon) {
      return navigation.getIconName(route, icon, this.$route);
    },

    isActiveRoute(name) {
      return this.$route.name?.startsWith(name);
    },

    trackCatalogClick() {
      this.$mixpanel.track('Crux Catalog Viewed');
    },

    trackHealthDashboardClick() {
      this.$mixpanel.track('Health Dashboard Viewed');
    },
  },
};
</script>

<i18n lang="json">
{
  "en": {
    "menuItems": {
      "backfill": "Backfill",
      "catalog": "Crux Catalog",
      "connections": "Connections",
      "healthDashboard": "Health Dashboard",
      "navigator": "Metadata Navigator",
      "notifications": "Notifications",
      "organizations": "Organizations",
      "users": "Users"
    }
  }
}
</i18n>
